import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {Person} from '../../../class/person';
import {NbDialogRef} from '@nebular/theme';
import {Router} from '@angular/router';

@Component({
  selector: 'app-person-chooser-dialog',
  templateUrl: './person-chooser-dialog.component.html',
  styleUrls: ['./person-chooser-dialog.component.css']
})
export class PersonChooserDialogComponent extends BaseDialog<Person> implements OnInit {

  @Input()
  people: Person[];

  constructor(dialogRef: NbDialogRef<Person>, route: Router) {
    super(dialogRef, route);
  }
  ngOnInit() {
  }
}
